import { CoreFileCard, type CoreFileItem } from "@verity/components/core";
import { FileSubmissionAnswer } from "@verity/api-client/types";
import styles from "./QuestionAnswer.module.css";
import { AnswerStatusChip, deriveFileDisplayName } from "./shared";
import type { QuizResponseResult } from "../hooks/verityAssessmentResultHelper.js";

/** Manually graded, no correctness check.
 * fileSize falls back to 0KB for submissions uploaded before that field existed. */
export function FileSubmissionAnswerView({ response }: { response: QuizResponseResult | undefined }) {
	const files = (response?.answer as FileSubmissionAnswer | undefined) ?? [];
	if (response?.isAnswered !== true || files.length === 0) {
		return <AnswerStatusChip userText="" isCorrect={null} style={{ margin: "0" }} />;
	}
	return (
		<div className={styles.fileAnswerList}>
			{files.map((file) => {
				const coreFile: CoreFileItem = {
					name: deriveFileDisplayName(file.fileName),
					size: file.fileSize ?? 0,
					url: file.fileUrl ?? undefined,
				};
				return (
					<div key={file.fileName} className={styles.fileAnswerItem}>
						<CoreFileCard file={coreFile} showOpenInNewTab />
					</div>
				);
			})}
		</div>
	);
}
